import { GetInspectionsMetricsInDto, GetInspectionsMetricsOutDto } from '../../../types/inspection.dto'

export const GET_INSPECTIONS_METRICS = 'GET_INSPECTIONS_METRICS'
export const GET_INSPECTIONS_METRICS_SUCCESS = 'GET_INSPECTIONS_METRICS_SUCCESS'
export const GET_INSPECTIONS_METRICS_ERROR = 'GET_INSPECTIONS_METRICS_ERROR'
export const RESET_GET_INSPECTIONS_METRICS = 'RESET_GET_INSPECTIONS_METRICS'

export interface GetInspectionsMetrics {
  type: typeof GET_INSPECTIONS_METRICS
  payload: GetInspectionsMetricsOutDto
}

export interface GetInspectionsMetricsSuccess {
  type: typeof GET_INSPECTIONS_METRICS_SUCCESS
  payload: GetInspectionsMetricsInDto
}

export interface GetInspectionsMetricsError {
  type: typeof GET_INSPECTIONS_METRICS_ERROR
  payload: string | boolean
}

export interface ResetGetInspectionsMetrics {
  type: typeof RESET_GET_INSPECTIONS_METRICS
  payload: null
}

export interface State {
  data: GetInspectionsMetricsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetInspectionsMetrics | GetInspectionsMetricsSuccess | GetInspectionsMetricsError | ResetGetInspectionsMetrics
